import { Injectable } from '@angular/core';
import { RestClientAuthService } from 'src/app/core/services/rest-client';

@Injectable()
export class LoginRestClientService {
  constructor(private restClientAuthService: RestClientAuthService) {}
}
